import styled from 'styled-components'
import { QuestionOutlined } from '@ant-design/icons'
import { TYPOGRAPHY } from '../../../styles/theme'

export const InfoIcon = styled(QuestionOutlined)<{ $color?: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  border-radius: 50%;
  border: 1px solid ${(props) => props.$color ?? 'var(--color-text-tertiary)'};
  color: ${(props) => props.$color ?? 'var(--color-text-tertiary)'};
  cursor: pointer;
  transition:
    border-color 0.2s,
    color 0.2s;

  &:hover {
    border-color: var(--ant-color-primary);
    color: var(--ant-color-primary);
  }
`
